var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 376,
    viewBox: "0 0 358 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_34490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.535 376.968C259.515 357.098 225.254 296.58 282.083 272.349C338.911 248.119 341.755 200.671 373.177 194.339",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.177 411C234.568 362.965 207.308 216.758 264.122 189.315C320.936 161.872 297.095 218.864 330.067 218.864C363.04 218.864 377.413 190.197 396.012 189.315",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.416 391.844C251.577 352.226 239.914 189.214 297.08 182.645C354.25 176.077 355.32 263.852 388.749 272.476",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.094 389.834C251.117 345.641 229.212 182.696 294.077 165.992C358.947 149.288 356.594 213.491 383.066 215.635",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.67 410.916C281.83 360.47 246.509 213.904 300.523 193.646C354.543 173.388 363.253 243.264 390.235 245.653",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 434C297.273 402.206 273.847 305.435 322.671 287.271C371.494 269.107 351.006 306.829 379.341 306.829C407.677 306.829 420.029 287.855 436.012 287.271",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.944 419.991C311.494 390.74 292.671 282.89 348.413 271.834C404.16 260.778 402.138 303.272 424.887 304.692",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.407 433.944C337.888 400.555 307.534 303.546 353.952 290.137C400.375 276.729 407.86 322.979 431.048 324.56",
    stroke: "#00AF57",
    strokeOpacity: 0.92,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_34490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 376,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore4);
export default __webpack_public_path__ + "static/media/explore4.1eff03fe05cba351d4d177ed235e5721.svg";
export { ForwardRef as ReactComponent };